import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import MuiTableSortLabel from '@material-ui/core/TableSortLabel';

const TableSortLabel = ({ label, field, container }) => {
  const { sort, setProperty, updateItems } = container.props;

  return (
    <TableCell>
      <MuiTableSortLabel
        active={sort.field === field}
        direction={sort.direction}
        onClick={() =>
          setProperty(
            container,
            'sort',
            {
              field,
              direction:
                sort.direction === 'desc' || field !== sort.field
                  ? 'asc'
                  : 'desc',
            },
            updateItems
          )
        }
      >
        {label}
      </MuiTableSortLabel>
    </TableCell>
  );
};

export default TableSortLabel;
